export default { sha: '9223ee3eb396a840a78da2b3befee4b82b5ca6a1', buildNumber: 'undefined' }
